// 爻的类型
export const YAO_TYPES = {
  OLD_YANG: '老阳',     // 老阳 ○ (三正)
  OLD_YIN: '老阴',      // 老阴 × (三反)
  YOUNG_YANG: '少阳', // 少阳 --- (一正两反)
  YOUNG_YIN: '少阴'    // 少阴 -- (两正一反)
}

// 爻的位置
export const YAO_POSITIONS = ['初爻', '二爻', '三爻', '四爻', '五爻', '上爻']

// 爻的符号
export const YAO_SYMBOLS = {
  [YAO_TYPES.YOUNG_YANG]: '▬▬▬',
  [YAO_TYPES.YOUNG_YIN]: '▬ ▬',
  [YAO_TYPES.OLD_YANG]: '▬○▬',
  [YAO_TYPES.OLD_YIN]: '▬×▬'
}

// 判断是否为变爻（老阳或老阴）
export const isChangingYao = (yaoType) => {
  return yaoType === YAO_TYPES.OLD_YANG || yaoType === YAO_TYPES.OLD_YIN
}

// 爻的硬币组合
export const YAO_COINS = {
  [YAO_TYPES.OLD_YANG]: [true, true, true],      // 三正为老阳
  [YAO_TYPES.YOUNG_YIN]: [true, true, false],    // 两正一反为少阴
  [YAO_TYPES.YOUNG_YANG]: [true, false, false],  // 一正两反为少阳
  [YAO_TYPES.OLD_YIN]: [false, false, false]     // 三反为老阴
}